<template>
  <el-tooltip
    :content="txtInfo"
    placement="top"
    effect="dark"
    :disabled="isDisabled"
  >
    <div class="wordnowrap" @mouseenter="isShowTooltip">{{ txtInfo }}</div>
  </el-tooltip>
</template>

<script>
export default {
  name:"tooltip",
  props: {
    txtInfo: ""
  },
  data() {
    return {
      isDisabled: false
    };
  },
  methods: {
    isShowTooltip(e) {
      let clientWidth = e.target.clientWidth,
        scrollWidth = e.target.scrollWidth;
      if (scrollWidth > clientWidth) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wordnowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
